/**
 * FIZITI Cart Drawer
 * Handles all cart interactions: open/close, AJAX add/update/remove
 */

(function () {
  'use strict';

  const FREE_SHIPPING_THRESHOLD = 15000; // cents ($150.00) ??adjust as needed

  /* ?? Helpers ?????????????????????????????????????????????????? */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function imgTag(src, alt, w) {
    const u = src.replace(/(\.[^.]+)$/, `_${w}x$1`);
    return `<img src="${u}" alt="${alt}" loading="lazy" width="${w}" height="${w}" class="cd-item__img">`;
  }

  /* ?? Cart API ?????????????????????????????????????????????????? */
  async function getCart() {
    const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
    return res.json();
  }

  async function addItem(formData) {
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (!res.ok) {
      const err = await res.json();
      throw new Error(err.description || 'Could not add item');
    }
    return res.json();
  }

  async function changeItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    return res.json();
  }

  /* ?? Render ???????????????????????????????????????????????????? */
  function renderShipping(totalCents) {
    const fill    = document.getElementById('cd-shipping-fill');
    const text    = document.getElementById('cd-shipping-text');
    if (!fill || !text) return;

    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      text.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="color:#22c55e;flex-shrink:0"><polyline points="20 6 9 17 4 12"/></svg> <em>You\'ve unlocked free shipping!</em>';
      fill.style.width = '100%';
    } else {
      const remaining = FREE_SHIPPING_THRESHOLD - totalCents;
      text.innerHTML = `Add <em>${money(remaining)}</em> more for <em>free shipping</em>`;
      fill.style.width = ((totalCents / FREE_SHIPPING_THRESHOLD) * 100).toFixed(1) + '%';
    }
  }

  function renderItems(cart) {
    const body    = document.getElementById('cd-body');
    const foot    = document.getElementById('cd-foot');
    const count   = document.getElementById('cd-count');
    const subtotal = document.getElementById('cd-subtotal');
    const headerCount = document.getElementById('header-cart-count');

    if (count) count.textContent = cart.item_count;
    if (subtotal) subtotal.textContent = money(cart.total_price);
    if (headerCount) {
      headerCount.textContent = cart.item_count;
      headerCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    renderShipping(cart.total_price);

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cd-empty">
          <div class="cd-empty__icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
          </div>
          <p class="cd-empty__title">Your cart is empty</p>
          <p class="cd-empty__sub">Looks like you haven't added anything yet.</p>
          <a href="/collections/all" class="cd-empty__btn">Shop Now</a>
        </div>`;
      if (foot) foot.style.display = 'none';
      return;
    }

    if (foot) foot.style.display = 'flex';

    const items = cart.items.map(item => {
      const imgSrc = item.image ? item.image.replace(/(\.[^.?]+)(\?.*)?$/, '_160x$1') : '';
      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="cd-item__variant">${item.variant_title}</p>` : '';

      return `
        <li class="cd-item" data-key="${item.key}">
          <a href="${item.url}" class="cd-item__img-link" tabindex="-1">
            ${imgSrc ? `<img src="${imgSrc}" alt="${item.product_title}" class="cd-item__img" loading="lazy" width="80" height="80">` : ''}
          </a>
          <div class="cd-item__info">
            <a href="${item.url}" class="cd-item__title">${item.product_title}</a>
            ${variantHtml}
            <div class="cd-item__bottom">
              <div class="cd-qty">
                <button class="cd-qty__btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
                <span class="cd-qty__val">${item.quantity}</span>
                <button class="cd-qty__btn" data-action="increase" data-key="${item.key}" aria-label="Increase">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </button>
              </div>
              <span class="cd-item__price">${money(item.final_line_price)}</span>
            </div>
          </div>
          <button class="cd-item__remove" data-key="${item.key}" aria-label="Remove ${item.product_title}">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </li>`;
    }).join('');

    body.innerHTML = `<ul class="cd-items" id="cd-items" role="list">${items}</ul>`;
  }

  /* ?? Toast feedback ???????????????????????????????????????????? */
  let toastTimer;
  function showToast(msg, type = 'success') {
    let toast = document.getElementById('fiziti-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'fiziti-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);

      const style = document.createElement('style');
      style.textContent = `
        #fiziti-toast {
          position: fixed;
          bottom: 28px;
          left: 50%;
          transform: translateX(-50%) translateY(80px);
          background: #1e293b;
          color: #fff;
          padding: 12px 24px;
          border-radius: 40px;
          font-size: 14px;
          font-weight: 600;
          white-space: nowrap;
          z-index: 9999;
          box-shadow: 0 8px 24px rgba(0,0,0,0.2);
          transition: transform 0.35s cubic-bezier(0.34,1.2,0.64,1), opacity 0.35s ease;
          opacity: 0;
          pointer-events: none;
        }
        #fiziti-toast.is-visible {
          transform: translateX(-50%) translateY(0);
          opacity: 1;
        }
        #fiziti-toast.is-error { background: #dc2626; }
      `;
      document.head.appendChild(style);
    }

    clearTimeout(toastTimer);
    toast.textContent = msg;
    toast.className = type === 'error' ? 'is-error' : '';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => toast.classList.add('is-visible'));
    });

    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  /* ?? Drawer open / close ??????????????????????????????????????? */
  const drawer   = document.getElementById('cart-drawer');
  const backdrop = document.getElementById('cart-drawer-backdrop');
  const closeBtn = document.getElementById('cart-drawer-close');

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function openDrawer() {
    if (!drawer) return;
    var sw = getScrollbarWidth();
    if (sw > 0) {
      document.body.style.paddingRight = sw + 'px';
      var siteHeader = document.querySelector('.site-header');
      if (siteHeader) siteHeader.style.paddingRight = sw + 'px';
    }
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    closeBtn?.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.paddingRight = '';
    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) siteHeader.style.paddingRight = '';
  }

  /* ?? Button state helpers ?????????????????????????????????????? */
  function setAtcLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.origHtml = btn.innerHTML;
      btn.innerHTML = `<svg class="spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>Adding?`;
      btn.disabled = true;
      btn.style.opacity = '0.8';
    } else if (btn.dataset.origHtml) {
      btn.innerHTML = btn.dataset.origHtml;
      btn.disabled = false;
      btn.style.opacity = '';
    }
  }

  function setAtcSuccess(btn) {
    if (!btn || !btn.dataset.origHtml) return;
    btn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Added!`;
    btn.style.background = '#16a34a';
    setTimeout(() => {
      btn.innerHTML = btn.dataset.origHtml;
      btn.style.background = '';
      btn.disabled = false;
      btn.style.opacity = '';
    }, 1800);
  }

  /* ?? Event delegation on drawer body ?????????????????????????? */
  document.addEventListener('click', async (e) => {
    // Qty buttons
    const qtyBtn = e.target.closest('.cd-qty__btn');
    if (qtyBtn) {
      e.preventDefault();
      const key      = qtyBtn.dataset.key;
      const item     = qtyBtn.closest('.cd-item');
      const valEl    = item?.querySelector('.cd-qty__val');
      const current  = parseInt(valEl?.textContent) || 1;
      const next     = qtyBtn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);

      if (item) item.classList.add('is-loading');
      try {
        const cart = await changeItem(key, next);
        renderItems(cart);
      } catch {
        showToast('Something went wrong', 'error');
      }
      return;
    }

    // Remove buttons
    const removeBtn = e.target.closest('.cd-item__remove');
    if (removeBtn) {
      e.preventDefault();
      const key  = removeBtn.dataset.key;
      const item = removeBtn.closest('.cd-item');
      if (item) {
        item.classList.add('is-removing');
        await new Promise(r => setTimeout(r, 280));
      }
      try {
        const cart = await changeItem(key, 0);
        renderItems(cart);
      } catch {
        showToast('Something went wrong', 'error');
      }
      return;
    }

    // Backdrop close
    if (e.target === backdrop) closeDrawer();
  });

  closeBtn?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  /* ?? Trigger from header cart button ??????????????????????????? */
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cart-trigger]');
    if (!trigger) return;
    e.preventDefault();
    // ??????????????
    openDrawer();
    // ??????
    getCart().then(cart => renderItems(cart)).catch(() => {});
  });

  /* ?? Intercept all Add to Cart forms ??????????????????????????? */
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (form.getAttribute('action') !== '/cart/add' &&
        form.getAttribute('action') !== `${window.Shopify?.routes?.root || '/'}cart/add`) return;
    if (form.dataset.noAjax) return;

    e.preventDefault();

    const btn      = form.querySelector('[type="submit"][name="add"], #pdp-atc-btn, .product-form__submit');
    const fd       = new FormData(form);

    setAtcLoading(btn);

    try {
      await addItem(fd);
      const cart = await getCart();
      renderItems(cart);
      setAtcSuccess(btn);
      openDrawer();
    } catch (err) {
      setAtcLoading(btn, false);
      showToast(err.message || 'Could not add to cart', 'error');
    }
  });

  /* ?? Spin animation for loading spinner ??????????????????????? */
  const spinStyle = document.createElement('style');
  spinStyle.textContent = `
    @keyframes cdSpin { to { transform: rotate(360deg); } }
    .spin { animation: cdSpin 0.7s linear infinite; display: inline-block; }
  `;
  document.head.appendChild(spinStyle);

  /* ?? Init: render shipping bar on page load ???????????????????? */
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const cart = await getCart();
      renderShipping(cart.total_price);
      // Update header count from live cart
      const headerCount = document.getElementById('header-cart-count');
      if (headerCount) {
        headerCount.textContent = cart.item_count;
        headerCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch {}
  });

  // Expose globally for other scripts
  window.FizitiCart = { open: openDrawer, close: closeDrawer, refresh: async () => {
    const cart = await getCart();
    renderItems(cart);
  }};
})();
